var _style, _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicketingIos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svgQrWrapper",
    viewBox: "0 0 300 300",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 300,
    height: 300,
    style: {
      width: "100%",
      height: "100%",
      backgroundColor: "rgb(255, 255, 255)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9, 9)scale(0.95)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".background-color{ fill: transparent; }.dot-color{ fill: #767474; }.corners-square-color-0-0{ fill: #0071BC; }.corners-dot-color-0-0{ fill: #0071BC; }.corners-square-color-1-0{ fill: #0071BC; }.corners-dot-color-1-0{ fill: #0071BC; }.corners-square-color-0-1{ fill: #0071BC; }.corners-dot-color-0-1{ fill: #0071BC; }")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "dot-color"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1 82v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,5.5,86.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 91,
    width: 9,
    height: 9,
    transform: "rotate(0,5.5,95.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1 109v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,5.5,113.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1 118v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,5.5,122.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1 163v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,5.5,167.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1 190v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,5.5,194.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1 208v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,5.5,212.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1 217v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,5.5,221.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 82,
    width: 9,
    height: 9,
    transform: "rotate(0,14.5,86.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 91,
    width: 9,
    height: 9,
    transform: "rotate(0,14.5,95.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 10 154v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,14.5,158.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 163,
    width: 9,
    height: 9,
    transform: "rotate(0,14.5,167.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 172,
    width: 9,
    height: 9,
    transform: "rotate(0,14.5,176.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 181,
    width: 9,
    height: 9,
    transform: "rotate(0,14.5,185.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 10 190v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,14.5,194.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 208,
    width: 9,
    height: 9,
    transform: "rotate(0,14.5,212.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 91,
    width: 9,
    height: 9,
    transform: "rotate(0,23.5,95.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 100,
    width: 9,
    height: 9,
    transform: "rotate(0,23.5,104.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 109,
    width: 9,
    height: 9,
    transform: "rotate(0,23.5,113.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 19 145v 4.5a 4.5 4.5, 0, 0, 0, 4.5 4.5h 4.5v -4.5a 4.5 4.5, 0, 0, 0, -4.5 -4.5",
    transform: "rotate(90,23.5,149.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 163,
    width: 9,
    height: 9,
    transform: "rotate(0,23.5,167.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 172,
    width: 9,
    height: 9,
    transform: "rotate(0,23.5,176.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 181,
    width: 9,
    height: 9,
    transform: "rotate(0,23.5,185.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 19 199v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,23.5,203.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 208,
    width: 9,
    height: 9,
    transform: "rotate(0,23.5,212.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 28 82v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,32.5,86.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 91,
    width: 9,
    height: 9,
    transform: "rotate(0,32.5,95.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 109,
    width: 9,
    height: 9,
    transform: "rotate(0,32.5,113.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 118,
    width: 9,
    height: 9,
    transform: "rotate(0,32.5,122.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 28 127v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,32.5,131.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 163,
    width: 9,
    height: 9,
    transform: "rotate(0,32.5,167.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 172,
    width: 9,
    height: 9,
    transform: "rotate(0,32.5,176.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 28 181v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,32.5,185.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 208,
    width: 9,
    height: 9,
    transform: "rotate(0,32.5,212.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 37 73v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,41.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 82,
    width: 9,
    height: 9,
    transform: "rotate(0,41.5,86.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 91,
    width: 9,
    height: 9,
    transform: "rotate(0,41.5,95.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 100,
    width: 9,
    height: 9,
    transform: "rotate(0,41.5,104.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 109,
    width: 9,
    height: 9,
    transform: "rotate(0,41.5,113.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 37 118v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,41.5,122.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 37 136v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,41.5,140.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 145,
    width: 9,
    height: 9,
    transform: "rotate(0,41.5,149.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 154,
    width: 9,
    height: 9,
    transform: "rotate(0,41.5,158.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 163,
    width: 9,
    height: 9,
    transform: "rotate(0,41.5,167.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 37 172v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,41.5,176.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 37 190v 4.5a 4.5 4.5, 0, 0, 0, 4.5 4.5h 4.5v -4.5a 4.5 4.5, 0, 0, 0, -4.5 -4.5",
    transform: "rotate(90,41.5,194.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 37 208v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,41.5,212.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 82,
    width: 9,
    height: 9,
    transform: "rotate(0,50.5,86.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 91,
    width: 9,
    height: 9,
    transform: "rotate(0,50.5,95.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 109,
    width: 9,
    height: 9,
    transform: "rotate(0,50.5,113.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 136,
    width: 9,
    height: 9,
    transform: "rotate(0,50.5,140.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 145,
    width: 9,
    height: 9,
    transform: "rotate(0,50.5,149.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 154,
    width: 9,
    height: 9,
    transform: "rotate(0,50.5,158.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 163,
    width: 9,
    height: 9,
    transform: "rotate(0,50.5,167.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 46 199v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,50.5,203.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 46 217v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,50.5,221.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 55 73v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,59.5,77.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 55 91v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,59.5,95.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 55 109v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,59.5,113.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 55 127v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,59.5,131.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 55 145v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,59.5,149.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 55 163v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,59.5,167.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 55 181v 4.5a 4.5 4.5, 0, 0, 0, 4.5 4.5h 4.5v -4.5a 4.5 4.5, 0, 0, 0, -4.5 -4.5",
    transform: "rotate(90,59.5,185.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 55 199v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,59.5,203.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 55 217v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,59.5,221.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 73,
    width: 9,
    height: 9,
    transform: "rotate(0,68.5,77.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 64 82v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,68.5,86.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 64 118v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,68.5,122.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 127,
    width: 9,
    height: 9,
    transform: "rotate(0,68.5,131.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 64 136v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,68.5,140.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 64 154v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,68.5,158.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 64 208v 4.5a 4.5 4.5, 0, 0, 0, 4.5 4.5h 4.5v -4.5a 4.5 4.5, 0, 0, 0, -4.5 -4.5",
    transform: "rotate(90,68.5,212.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 73 19v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,77.5,23.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 73 28v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,77.5,32.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 73 55v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,77.5,59.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 64,
    width: 9,
    height: 9,
    transform: "rotate(0,77.5,68.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 73 73v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,77.5,77.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 73 100v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,77.5,104.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 73 109v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,77.5,113.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 73 145v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,77.5,149.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 154,
    width: 9,
    height: 9,
    transform: "rotate(0,77.5,158.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 163,
    width: 9,
    height: 9,
    transform: "rotate(0,77.5,167.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 73 172v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,77.5,176.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 73 190v 4.5a 4.5 4.5, 0, 0, 0, 4.5 4.5h 4.5v -4.5a 4.5 4.5, 0, 0, 0, -4.5 -4.5",
    transform: "rotate(90,77.5,194.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 73 226v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,77.5,230.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 235,
    width: 9,
    height: 9,
    transform: "rotate(0,77.5,239.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 73 253v 4.5a 4.5 4.5, 0, 0, 0, 4.5 4.5h 4.5v -4.5a 4.5 4.5, 0, 0, 0, -4.5 -4.5",
    transform: "rotate(90,77.5,257.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 82 1v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,86.5,5.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 19,
    width: 9,
    height: 9,
    transform: "rotate(0,86.5,23.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 82 46v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,86.5,50.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 82 82v 4.5a 4.5 4.5, 0, 0, 0, 4.5 4.5h 4.5v -4.5a 4.5 4.5, 0, 0, 0, -4.5 -4.5",
    transform: "rotate(90,86.5,86.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 82 118v 4.5a 4.5 4.5, 0, 0, 0, 4.5 4.5h 4.5v -4.5a 4.5 4.5, 0, 0, 0, -4.5 -4.5",
    transform: "rotate(90,86.5,122.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 154,
    width: 9,
    height: 9,
    transform: "rotate(0,86.5,158.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 163,
    width: 9,
    height: 9,
    transform: "rotate(0,86.5,167.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 82 208v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,86.5,212.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 226,
    width: 9,
    height: 9,
    transform: "rotate(0,86.5,230.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 235,
    width: 9,
    height: 9,
    transform: "rotate(0,86.5,239.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 82 262v 4.5a 4.5 4.5, 0, 0, 0, 4.5 4.5h 4.5v -4.5a 4.5 4.5, 0, 0, 0, -4.5 -4.5",
    transform: "rotate(90,86.5,266.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 82 289v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,86.5,293.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 1,
    width: 9,
    height: 9,
    transform: "rotate(0,95.5,5.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 10,
    width: 9,
    height: 9,
    transform: "rotate(0,95.5,14.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 19,
    width: 9,
    height: 9,
    transform: "rotate(0,95.5,23.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 28,
    width: 9,
    height: 9,
    transform: "rotate(0,95.5,32.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 46,
    width: 9,
    height: 9,
    transform: "rotate(0,95.5,50.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 55,
    width: 9,
    height: 9,
    transform: "rotate(0,95.5,59.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 64,
    width: 9,
    height: 9,
    transform: "rotate(0,95.5,68.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 91 73v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,95.5,77.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 91 100v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,95.5,104.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 91 145v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,95.5,149.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 154,
    width: 9,
    height: 9,
    transform: "rotate(0,95.5,158.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 163,
    width: 9,
    height: 9,
    transform: "rotate(0,95.5,167.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 91 181v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,95.5,185.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 190,
    width: 9,
    height: 9,
    transform: "rotate(0,95.5,194.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 199,
    width: 9,
    height: 9,
    transform: "rotate(0,95.5,203.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 91 208v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,95.5,212.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 226,
    width: 9,
    height: 9,
    transform: "rotate(0,95.5,230.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 91 235v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,95.5,239.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 91 271v 4.5a 4.5 4.5, 0, 0, 0, 4.5 4.5h 4.5v -4.5a 4.5 4.5, 0, 0, 0, -4.5 -4.5",
    transform: "rotate(90,95.5,275.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 91 289v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,95.5,293.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 28,
    width: 9,
    height: 9,
    transform: "rotate(0,104.5,32.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 100 46v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,104.5,50.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 100,
    width: 9,
    height: 9,
    transform: "rotate(0,104.5,104.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 100 109v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,104.5,113.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 100 127v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,104.5,131.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 100 136v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,104.5,140.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 100 163v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,104.5,167.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 181,
    width: 9,
    height: 9,
    transform: "rotate(0,104.5,185.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 190,
    width: 9,
    height: 9,
    transform: "rotate(0,104.5,194.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 199,
    width: 9,
    height: 9,
    transform: "rotate(0,104.5,203.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 100 244v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,104.5,248.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 253,
    width: 9,
    height: 9,
    transform: "rotate(0,104.5,257.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 100 262v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,104.5,266.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 109 10v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,113.5,14.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 28,
    width: 9,
    height: 9,
    transform: "rotate(0,113.5,32.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 109 55v 4.5a 4.5 4.5, 0, 0, 0, 4.5 4.5h 4.5v -4.5a 4.5 4.5, 0, 0, 0, -4.5 -4.5",
    transform: "rotate(90,113.5,59.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 109 82v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,113.5,86.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 190,
    width: 9,
    height: 9,
    transform: "rotate(0,113.5,194.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 109 199v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,113.5,203.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 244,
    width: 9,
    height: 9,
    transform: "rotate(0,113.5,248.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 10,
    width: 9,
    height: 9,
    transform: "rotate(0,122.5,14.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 19,
    width: 9,
    height: 9,
    transform: "rotate(0,122.5,23.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 118 28v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,122.5,32.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 118 46v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,122.5,50.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 118 64v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,122.5,68.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 118 82v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,122.5,86.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 118 100v 4.5a 4.5 4.5, 0, 0, 0, 4.5 4.5h 4.5v -4.5a 4.5 4.5, 0, 0, 0, -4.5 -4.5",
    transform: "rotate(90,122.5,104.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 190,
    width: 9,
    height: 9,
    transform: "rotate(0,122.5,194.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 118 217v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,122.5,221.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 244,
    width: 9,
    height: 9,
    transform: "rotate(0,122.5,248.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 118 253v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,122.5,257.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 118 271v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,122.5,275.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 127 1v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,131.5,5.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 127 19v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,131.5,23.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 127 37v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,131.5,41.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 46,
    width: 9,
    height: 9,
    transform: "rotate(0,131.5,50.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 55,
    width: 9,
    height: 9,
    transform: "rotate(0,131.5,59.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 127 64v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,131.5,68.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 190,
    width: 9,
    height: 9,
    transform: "rotate(0,131.5,194.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 217,
    width: 9,
    height: 9,
    transform: "rotate(0,131.5,221.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 127 262v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,131.5,266.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 271,
    width: 9,
    height: 9,
    transform: "rotate(0,131.5,275.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 1,
    width: 9,
    height: 9,
    transform: "rotate(0,140.5,5.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 46,
    width: 9,
    height: 9,
    transform: "rotate(0,140.5,50.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 136 73v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,140.5,77.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 136 91v 4.5a 4.5 4.5, 0, 0, 0, 4.5 4.5h 4.5v -4.5a 4.5 4.5, 0, 0, 0, -4.5 -4.5",
    transform: "rotate(90,140.5,95.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 190,
    width: 9,
    height: 9,
    transform: "rotate(0,140.5,194.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 136 199v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,140.5,203.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 217,
    width: 9,
    height: 9,
    transform: "rotate(0,140.5,221.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 226,
    width: 9,
    height: 9,
    transform: "rotate(0,140.5,230.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 136 253v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,140.5,257.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 262,
    width: 9,
    height: 9,
    transform: "rotate(0,140.5,266.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 271,
    width: 9,
    height: 9,
    transform: "rotate(0,140.5,275.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 145 1v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,149.5,5.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 145 19v 4.5a 4.5 4.5, 0, 0, 0, 4.5 4.5h 4.5v -4.5a 4.5 4.5, 0, 0, 0, -4.5 -4.5",
    transform: "rotate(90,149.5,23.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 46,
    width: 9,
    height: 9,
    transform: "rotate(0,149.5,50.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 145 55v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,149.5,59.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 73,
    width: 9,
    height: 9,
    transform: "rotate(0,149.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 190,
    width: 9,
    height: 9,
    transform: "rotate(0,149.5,194.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 145 208v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,149.5,212.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 217,
    width: 9,
    height: 9,
    transform: "rotate(0,149.5,221.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 226,
    width: 9,
    height: 9,
    transform: "rotate(0,149.5,230.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 235,
    width: 9,
    height: 9,
    transform: "rotate(0,149.5,239.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 244,
    width: 9,
    height: 9,
    transform: "rotate(0,149.5,248.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 253,
    width: 9,
    height: 9,
    transform: "rotate(0,149.5,257.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 262,
    width: 9,
    height: 9,
    transform: "rotate(0,149.5,266.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 271,
    width: 9,
    height: 9,
    transform: "rotate(0,149.5,275.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 280,
    width: 9,
    height: 9,
    transform: "rotate(0,149.5,284.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 154 64v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,158.5,68.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 73,
    width: 9,
    height: 9,
    transform: "rotate(0,158.5,77.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 154 91v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,158.5,95.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 154 100v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,158.5,104.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 190,
    width: 9,
    height: 9,
    transform: "rotate(0,158.5,194.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 199,
    width: 9,
    height: 9,
    transform: "rotate(0,158.5,203.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 154 208v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,158.5,212.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 226,
    width: 9,
    height: 9,
    transform: "rotate(0,158.5,230.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 154 235v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,158.5,239.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 253,
    width: 9,
    height: 9,
    transform: "rotate(0,158.5,257.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 271,
    width: 9,
    height: 9,
    transform: "rotate(0,158.5,275.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 280,
    width: 9,
    height: 9,
    transform: "rotate(0,158.5,284.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 154 289v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,158.5,293.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 163 1v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,167.5,5.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 10,
    width: 9,
    height: 9,
    transform: "rotate(0,167.5,14.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 19,
    width: 9,
    height: 9,
    transform: "rotate(0,167.5,23.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 28,
    width: 9,
    height: 9,
    transform: "rotate(0,167.5,32.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 37,
    width: 9,
    height: 9,
    transform: "rotate(0,167.5,41.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 46,
    width: 9,
    height: 9,
    transform: "rotate(0,167.5,50.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 55,
    width: 9,
    height: 9,
    transform: "rotate(0,167.5,59.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 64,
    width: 9,
    height: 9,
    transform: "rotate(0,167.5,68.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 73,
    width: 9,
    height: 9,
    transform: "rotate(0,167.5,77.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 163 82v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,167.5,86.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 163 199v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,167.5,203.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 253,
    width: 9,
    height: 9,
    transform: "rotate(0,167.5,257.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 271,
    width: 9,
    height: 9,
    transform: "rotate(0,167.5,275.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 280,
    width: 9,
    height: 9,
    transform: "rotate(0,167.5,284.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 1,
    width: 9,
    height: 9,
    transform: "rotate(0,176.5,5.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 19,
    width: 9,
    height: 9,
    transform: "rotate(0,176.5,23.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 172 28v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,176.5,32.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 46,
    width: 9,
    height: 9,
    transform: "rotate(0,176.5,50.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 172 226v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,176.5,230.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 235,
    width: 9,
    height: 9,
    transform: "rotate(0,176.5,239.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 244,
    width: 9,
    height: 9,
    transform: "rotate(0,176.5,248.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 172 253v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,176.5,257.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 280,
    width: 9,
    height: 9,
    transform: "rotate(0,176.5,284.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 172 289v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,176.5,293.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 1,
    width: 9,
    height: 9,
    transform: "rotate(0,185.5,5.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 181 37v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,185.5,41.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 46,
    width: 9,
    height: 9,
    transform: "rotate(0,185.5,50.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 55,
    width: 9,
    height: 9,
    transform: "rotate(0,185.5,59.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 64,
    width: 9,
    height: 9,
    transform: "rotate(0,185.5,68.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 181 100v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,185.5,104.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 181 190v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,185.5,194.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 226,
    width: 9,
    height: 9,
    transform: "rotate(0,185.5,230.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 181 262v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,185.5,266.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 181 271v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,185.5,275.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 1,
    width: 9,
    height: 9,
    transform: "rotate(0,194.5,5.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 190 10v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,194.5,14.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 37,
    width: 9,
    height: 9,
    transform: "rotate(0,194.5,41.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 46,
    width: 9,
    height: 9,
    transform: "rotate(0,194.5,50.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 64,
    width: 9,
    height: 9,
    transform: "rotate(0,194.5,68.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 190 82v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,194.5,86.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 91,
    width: 9,
    height: 9,
    transform: "rotate(0,194.5,95.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 100,
    width: 9,
    height: 9,
    transform: "rotate(0,194.5,104.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 109,
    width: 9,
    height: 9,
    transform: "rotate(0,194.5,113.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 118,
    width: 9,
    height: 9,
    transform: "rotate(0,194.5,122.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 127,
    width: 9,
    height: 9,
    transform: "rotate(0,194.5,131.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 136,
    width: 9,
    height: 9,
    transform: "rotate(0,194.5,140.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 190 163v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,194.5,167.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 172,
    width: 9,
    height: 9,
    transform: "rotate(0,194.5,176.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 190,
    width: 9,
    height: 9,
    transform: "rotate(0,194.5,194.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 190 226v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,194.5,230.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 262,
    width: 9,
    height: 9,
    transform: "rotate(0,194.5,266.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 190 289v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,194.5,293.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 199 19v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,203.5,23.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 199 28v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,203.5,32.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 46,
    width: 9,
    height: 9,
    transform: "rotate(0,203.5,50.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 55,
    width: 9,
    height: 9,
    transform: "rotate(0,203.5,59.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 199 64v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,203.5,68.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 82,
    width: 9,
    height: 9,
    transform: "rotate(0,203.5,86.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 199 100v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,203.5,104.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 199 118v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,203.5,122.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 199 136v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,203.5,140.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 172,
    width: 9,
    height: 9,
    transform: "rotate(0,203.5,176.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 190,
    width: 9,
    height: 9,
    transform: "rotate(0,203.5,194.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 199 199v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,203.5,203.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 199 235v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,203.5,239.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 244,
    width: 9,
    height: 9,
    transform: "rotate(0,203.5,248.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 262,
    width: 9,
    height: 9,
    transform: "rotate(0,203.5,266.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 271,
    width: 9,
    height: 9,
    transform: "rotate(0,203.5,275.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 280,
    width: 9,
    height: 9,
    transform: "rotate(0,203.5,284.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 289,
    width: 9,
    height: 9,
    transform: "rotate(0,203.5,293.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 208 10v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,212.5,14.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 19,
    width: 9,
    height: 9,
    transform: "rotate(0,212.5,23.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 208 37v 4.5a 4.5 4.5, 0, 0, 0, 4.5 4.5h 4.5v -4.5a 4.5 4.5, 0, 0, 0, -4.5 -4.5",
    transform: "rotate(90,212.5,41.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 208 73v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,212.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 82,
    width: 9,
    height: 9,
    transform: "rotate(0,212.5,86.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 208 127v 4.5a 4.5 4.5, 0, 0, 0, 4.5 4.5h 4.5v -4.5a 4.5 4.5, 0, 0, 0, -4.5 -4.5",
    transform: "rotate(90,212.5,131.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 208 154v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,212.5,158.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 163,
    width: 9,
    height: 9,
    transform: "rotate(0,212.5,167.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 172,
    width: 9,
    height: 9,
    transform: "rotate(0,212.5,176.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 208 181v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,212.5,185.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 208 208v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,212.5,212.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 217,
    width: 9,
    height: 9,
    transform: "rotate(0,212.5,221.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 226,
    width: 9,
    height: 9,
    transform: "rotate(0,212.5,230.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 244,
    width: 9,
    height: 9,
    transform: "rotate(0,212.5,248.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 208 262v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,212.5,266.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 208 289v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,212.5,293.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 217 1v 4.5a 4.5 4.5, 0, 0, 0, 4.5 4.5h 4.5v -4.5a 4.5 4.5, 0, 0, 0, -4.5 -4.5",
    transform: "rotate(90,221.5,5.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 19,
    width: 9,
    height: 9,
    transform: "rotate(0,221.5,23.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 217 28v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,221.5,32.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 217 55v 4.5a 4.5 4.5, 0, 0, 0, 4.5 4.5h 4.5v -4.5a 4.5 4.5, 0, 0, 0, -4.5 -4.5",
    transform: "rotate(90,221.5,59.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 82,
    width: 9,
    height: 9,
    transform: "rotate(0,221.5,86.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 217 109v 4.5a 4.5 4.5, 0, 0, 0, 4.5 4.5h 4.5v -4.5a 4.5 4.5, 0, 0, 0, -4.5 -4.5",
    transform: "rotate(90,221.5,113.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 163,
    width: 9,
    height: 9,
    transform: "rotate(0,221.5,167.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 172,
    width: 9,
    height: 9,
    transform: "rotate(0,221.5,176.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 217 199v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,221.5,203.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 208,
    width: 9,
    height: 9,
    transform: "rotate(0,221.5,212.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 217,
    width: 9,
    height: 9,
    transform: "rotate(0,221.5,221.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 226,
    width: 9,
    height: 9,
    transform: "rotate(0,221.5,230.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 235,
    width: 9,
    height: 9,
    transform: "rotate(0,221.5,239.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 244,
    width: 9,
    height: 9,
    transform: "rotate(0,221.5,248.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 253,
    width: 9,
    height: 9,
    transform: "rotate(0,221.5,257.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 226 73v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,230.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 82,
    width: 9,
    height: 9,
    transform: "rotate(0,230.5,86.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 226 118v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,230.5,122.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 226 136v 4.5a 4.5 4.5, 0, 0, 0, 4.5 4.5h 4.5v -4.5a 4.5 4.5, 0, 0, 0, -4.5 -4.5",
    transform: "rotate(90,230.5,140.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 226 154v 4.5a 4.5 4.5, 0, 0, 0, 4.5 4.5h 4.5v -4.5a 4.5 4.5, 0, 0, 0, -4.5 -4.5",
    transform: "rotate(90,230.5,158.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 172,
    width: 9,
    height: 9,
    transform: "rotate(0,230.5,176.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 181,
    width: 9,
    height: 9,
    transform: "rotate(0,230.5,185.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 199,
    width: 9,
    height: 9,
    transform: "rotate(0,230.5,203.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 217,
    width: 9,
    height: 9,
    transform: "rotate(0,230.5,221.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 253,
    width: 9,
    height: 9,
    transform: "rotate(0,230.5,257.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 226 271v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,230.5,275.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 226 280v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,230.5,284.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 73,
    width: 9,
    height: 9,
    transform: "rotate(0,239.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 82,
    width: 9,
    height: 9,
    transform: "rotate(0,239.5,86.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 91,
    width: 9,
    height: 9,
    transform: "rotate(0,239.5,95.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 118,
    width: 9,
    height: 9,
    transform: "rotate(0,239.5,122.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 127,
    width: 9,
    height: 9,
    transform: "rotate(0,239.5,131.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 235 163v 4.5a 4.5 4.5, 0, 0, 0, 4.5 4.5h 4.5v -4.5a 4.5 4.5, 0, 0, 0, -4.5 -4.5",
    transform: "rotate(90,239.5,167.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 235 181v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,239.5,185.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 199,
    width: 9,
    height: 9,
    transform: "rotate(0,239.5,203.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 208,
    width: 9,
    height: 9,
    transform: "rotate(0,239.5,212.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 217,
    width: 9,
    height: 9,
    transform: "rotate(0,239.5,221.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 235 235v 4.5a 4.5 4.5, 0, 0, 0, 4.5 4.5h 4.5v -4.5a 4.5 4.5, 0, 0, 0, -4.5 -4.5",
    transform: "rotate(90,239.5,239.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 253,
    width: 9,
    height: 9,
    transform: "rotate(0,239.5,257.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 235 262v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,239.5,266.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 91,
    width: 9,
    height: 9,
    transform: "rotate(0,248.5,95.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 100,
    width: 9,
    height: 9,
    transform: "rotate(0,248.5,104.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 109,
    width: 9,
    height: 9,
    transform: "rotate(0,248.5,113.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 127,
    width: 9,
    height: 9,
    transform: "rotate(0,248.5,131.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 244 154v 4.5a 4.5 4.5, 0, 0, 0, 4.5 4.5h 4.5v -4.5a 4.5 4.5, 0, 0, 0, -4.5 -4.5",
    transform: "rotate(90,248.5,158.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 244 172v 4.5a 4.5 4.5, 0, 0, 0, 4.5 4.5h 4.5v -4.5a 4.5 4.5, 0, 0, 0, -4.5 -4.5",
    transform: "rotate(90,248.5,176.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 244 190v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,248.5,194.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 244 199v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,248.5,203.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 217,
    width: 9,
    height: 9,
    transform: "rotate(0,248.5,221.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 253,
    width: 9,
    height: 9,
    transform: "rotate(0,248.5,257.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 244 271v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,248.5,275.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 280,
    width: 9,
    height: 9,
    transform: "rotate(0,248.5,284.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 244 289v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,248.5,293.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 253 82v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,257.5,86.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 91,
    width: 9,
    height: 9,
    transform: "rotate(0,257.5,95.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 100,
    width: 9,
    height: 9,
    transform: "rotate(0,257.5,104.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 109,
    width: 9,
    height: 9,
    transform: "rotate(0,257.5,113.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 118,
    width: 9,
    height: 9,
    transform: "rotate(0,257.5,122.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 127,
    width: 9,
    height: 9,
    transform: "rotate(0,257.5,131.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 253 145v 4.5a 4.5 4.5, 0, 0, 0, 4.5 4.5h 4.5v -4.5a 4.5 4.5, 0, 0, 0, -4.5 -4.5",
    transform: "rotate(90,257.5,149.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 253 163v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,257.5,167.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 253 208v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,257.5,212.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 217,
    width: 9,
    height: 9,
    transform: "rotate(0,257.5,221.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 226,
    width: 9,
    height: 9,
    transform: "rotate(0,257.5,230.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 235,
    width: 9,
    height: 9,
    transform: "rotate(0,257.5,239.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 244,
    width: 9,
    height: 9,
    transform: "rotate(0,257.5,248.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 253,
    width: 9,
    height: 9,
    transform: "rotate(0,257.5,257.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 262,
    width: 9,
    height: 9,
    transform: "rotate(0,257.5,266.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 271,
    width: 9,
    height: 9,
    transform: "rotate(0,257.5,275.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 253 280v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,257.5,284.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 262 73v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,266.5,77.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 262 109v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,266.5,113.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262,
    y: 127,
    width: 9,
    height: 9,
    transform: "rotate(0,266.5,131.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262,
    y: 136,
    width: 9,
    height: 9,
    transform: "rotate(0,266.5,140.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262,
    y: 163,
    width: 9,
    height: 9,
    transform: "rotate(0,266.5,167.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262,
    y: 172,
    width: 9,
    height: 9,
    transform: "rotate(0,266.5,176.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262,
    y: 181,
    width: 9,
    height: 9,
    transform: "rotate(0,266.5,185.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 262 190v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,266.5,194.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 262 217v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,266.5,221.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 262 244v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,266.5,248.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271,
    y: 73,
    width: 9,
    height: 9,
    transform: "rotate(0,275.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271,
    y: 82,
    width: 9,
    height: 9,
    transform: "rotate(0,275.5,86.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271,
    y: 91,
    width: 9,
    height: 9,
    transform: "rotate(0,275.5,95.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271,
    y: 100,
    width: 9,
    height: 9,
    transform: "rotate(0,275.5,104.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 271 136v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,275.5,140.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271,
    y: 172,
    width: 9,
    height: 9,
    transform: "rotate(0,275.5,176.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 271 181v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,275.5,185.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 271 226v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,275.5,230.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 271 235v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,275.5,239.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 271 262v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,275.5,266.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 271 271v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,275.5,275.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 82,
    width: 9,
    height: 9,
    transform: "rotate(0,284.5,86.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 91,
    width: 9,
    height: 9,
    transform: "rotate(0,284.5,95.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 100,
    width: 9,
    height: 9,
    transform: "rotate(0,284.5,104.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 280 118v 4.5a 4.5 4.5, 0, 0, 0, 4.5 4.5h 4.5v -4.5a 4.5 4.5, 0, 0, 0, -4.5 -4.5",
    transform: "rotate(90,284.5,122.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 280 154v 4.5a 4.5 4.5, 0, 0, 0, 4.5 4.5h 4.5v -4.5a 4.5 4.5, 0, 0, 0, -4.5 -4.5",
    transform: "rotate(90,284.5,158.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 280 199v 4.5a 4.5 4.5, 0, 0, 0, 4.5 4.5h 4.5v -4.5a 4.5 4.5, 0, 0, 0, -4.5 -4.5",
    transform: "rotate(90,284.5,203.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 280 217v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,284.5,221.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 280 226v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,284.5,230.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 280 262v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,284.5,266.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 280 289v 4.5a 4.5 4.5, 0, 0, 0, 4.5 4.5h 4.5v -4.5a 4.5 4.5, 0, 0, 0, -4.5 -4.5",
    transform: "rotate(90,284.5,293.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 289 100v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,293.5,104.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 289 127v 4.5a 4.5 4.5, 0, 0, 0, 4.5 4.5h 4.5v -4.5a 4.5 4.5, 0, 0, 0, -4.5 -4.5",
    transform: "rotate(90,293.5,131.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 289 145v 4.5a 4.5 4.5, 0, 0, 0, 4.5 4.5h 4.5v -4.5a 4.5 4.5, 0, 0, 0, -4.5 -4.5",
    transform: "rotate(90,293.5,149.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 289 190v 4.5a 4.5 4.5, 0, 0, 0, 4.5 4.5h 4.5v -4.5a 4.5 4.5, 0, 0, 0, -4.5 -4.5",
    transform: "rotate(90,293.5,194.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 289 208v 4.5a 4.5 4.5, 0, 0, 0, 4.5 4.5h 4.5v -4.5a 4.5 4.5, 0, 0, 0, -4.5 -4.5",
    transform: "rotate(90,293.5,212.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 289 244v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(-90,293.5,248.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 289 253v 9h 9a 9 9, 0, 0, 0, -9 -9",
    transform: "rotate(90,293.5,257.5)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "green-dots"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "corners-square-color-0-0"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 32.5 1a 31.5 31.5 0 1 0 0.1 0zm 0 9a 22.5 22.5 0 1 1 -0.1 0Z",
    transform: "rotate(0,32.5,32.5)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "corners-dot-color-0-0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 19,
    width: 27,
    height: 27,
    rx: 6.75,
    ry: 6.75,
    transform: "rotate(0,32.5,32.5)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "corners-square-color-1-0"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 266.5 1a 31.5 31.5 0 1 0 0.1 0zm 0 9a 22.5 22.5 0 1 1 -0.1 0Z",
    transform: "rotate(90,266.5,32.5)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "corners-dot-color-1-0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 19,
    width: 27,
    height: 27,
    rx: 6.75,
    ry: 6.75,
    transform: "rotate(90,266.5,32.5)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "corners-square-color-0-1"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 32.5 235a 31.5 31.5 0 1 0 0.1 0zm 0 9a 22.5 22.5 0 1 1 -0.1 0Z",
    transform: "rotate(-90,32.5,266.5)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "corners-dot-color-0-1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 253,
    width: 27,
    height: 27,
    rx: 6.75,
    ry: 6.75,
    transform: "rotate(-90,32.5,266.5)"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    width: "77px",
    height: "67px",
    viewBox: "0 0 1088 955",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    x: 111,
    y: 116,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M821.253 426.117C820.131 426.566 819.682 427.912 820.355 429.034L843.466 476.154C867.924 469.871 894.177 481.09 905.62 504.65C918.859 531.576 907.864 563.887 880.938 577.126C854.012 590.364 821.702 579.37 808.463 552.444C796.795 528.884 803.975 501.06 823.945 485.802L800.834 438.682C795 426.79 799.937 412.43 811.829 406.596L986.173 320.658L840.774 25.8203C829.555 2.93336 801.956 -6.49072 779.069 4.72836L517.665 133.523L574.657 249.304C580.491 261.196 575.555 275.557 563.663 281.391L516.543 304.502C522.825 328.96 511.606 355.212 488.046 366.656C461.12 379.894 428.809 368.9 415.571 341.974C402.332 315.048 413.327 282.737 440.253 269.499C463.813 257.831 491.636 265.011 506.894 284.981L554.014 261.87C555.136 261.421 555.585 260.075 554.912 258.953L497.919 143.172L245.041 267.704C256.933 291.712 249.304 320.209 228.437 335.467C225.52 337.711 222.154 339.281 218.788 340.852L215.871 341.974C212.281 343.545 208.467 344.666 204.652 345.34C181.541 349.154 157.981 337.711 147.211 315.721L25.8202 375.407C2.93325 386.626 -6.49069 414.225 4.72839 437.112L247.06 929.18C258.28 952.067 285.878 961.491 308.765 950.272L430.156 890.587C418.039 866.129 426.117 837.184 447.657 821.926C447.657 821.926 452.818 818.56 457.081 816.765C483.559 805.097 514.972 816.316 527.762 842.569L752.143 732.173L571.067 364.636C565.233 352.744 570.17 338.384 582.062 332.55L629.182 309.439C622.899 284.981 634.118 258.728 657.678 247.285C684.604 234.046 716.915 245.041 730.154 271.967C743.392 298.893 732.398 331.204 705.472 344.442C681.912 356.11 654.089 348.93 638.831 328.96L591.711 352.071C590.589 352.52 590.14 353.866 590.813 354.988L771.889 722.525L1061.57 579.818C1084.45 568.599 1093.88 541 1082.66 518.113L995.148 340.403L821.253 426.117ZM349.154 600.013C351.847 598.666 355.437 599.788 356.783 602.481L361.719 612.578C363.066 615.271 361.944 618.861 359.251 620.207C356.559 621.553 352.968 620.431 351.622 617.739L346.686 607.642C345.115 604.949 346.461 601.359 349.154 600.013ZM336.14 586.325L331.203 576.228C329.857 573.536 330.979 569.945 333.672 568.599C336.364 567.253 339.954 568.375 341.301 571.067L346.237 581.165C347.583 583.857 346.461 587.447 343.544 588.794C340.852 590.364 337.486 589.018 336.14 586.325ZM364.636 631.65C367.329 630.304 370.919 631.426 372.265 634.119L377.202 644.216C378.548 646.908 377.426 650.498 374.509 651.845C371.817 653.191 368.226 652.069 366.88 649.377L361.944 639.279C360.598 636.362 361.944 632.997 364.636 631.65ZM222.603 355.885C221.257 353.193 222.378 349.603 225.071 348.257C227.764 346.91 231.354 348.032 232.7 350.725L237.636 360.822C238.983 363.514 237.861 367.105 235.168 368.451C232.476 369.797 228.885 368.675 227.539 365.983L222.603 355.885ZM238.085 387.299C236.739 384.606 237.861 381.016 240.553 379.67C243.246 378.324 246.836 379.446 248.182 382.363L253.119 392.46C254.465 395.152 253.343 398.742 250.426 400.089C247.734 401.435 244.143 400.313 242.797 397.62L238.085 387.299ZM253.567 418.937C252.221 416.244 253.343 412.654 256.036 411.308C258.728 409.961 262.318 411.083 263.665 414L268.601 424.097C269.947 426.79 268.825 430.38 266.133 431.727C263.44 433.073 259.85 431.951 258.504 429.258L253.567 418.937ZM271.742 442.721C274.435 441.375 278.025 442.497 279.371 445.189L284.308 455.287C285.654 457.979 284.532 461.569 281.84 462.915C279.147 464.262 275.557 463.14 274.211 460.447L269.274 450.35C267.703 447.433 268.825 444.067 271.742 442.721ZM297.097 494.553C294.405 495.9 290.815 494.778 289.468 492.085L284.532 481.988C283.186 479.295 284.308 475.705 287 474.359C289.693 473.013 293.283 474.135 294.629 476.827L299.566 486.924C301.136 489.841 300.014 493.207 297.097 494.553ZM310.336 508.241L315.272 518.338C316.619 521.03 315.497 524.62 312.804 525.967C310.112 527.313 306.521 526.191 305.175 523.498L300.239 513.401C298.893 510.709 300.014 507.119 302.707 505.772C305.4 504.202 308.99 505.548 310.336 508.241ZM315.497 544.815C314.151 542.122 315.272 538.532 317.965 537.186C320.658 535.84 324.248 536.961 325.594 539.654L330.53 549.751C331.877 552.444 330.755 556.034 328.062 557.38C325.37 558.726 321.78 557.604 320.433 554.912L315.497 544.815ZM377.651 670.468C376.304 667.776 377.426 664.186 380.119 662.839C382.811 661.493 386.401 662.615 387.748 665.532L392.684 675.629C394.03 678.322 392.908 681.912 389.991 683.258C387.299 684.604 383.709 683.483 382.362 680.79L377.651 670.468ZM405.698 714.672C403.006 716.018 399.415 714.896 398.069 712.203L393.133 702.106C391.786 699.414 392.908 695.824 395.601 694.477C398.294 693.131 401.884 694.253 403.23 696.945L408.166 707.043C409.513 709.96 408.391 713.325 405.698 714.672ZM418.712 728.583L423.649 738.68C424.995 741.373 423.873 744.963 421.18 746.309C418.488 747.656 414.898 746.534 413.552 743.841L408.615 733.744C407.269 731.051 408.391 727.461 411.083 726.115C414 724.544 417.366 725.666 418.712 728.583ZM454.613 801.507C455.96 804.2 454.838 807.79 452.145 809.136C449.452 810.482 445.862 809.361 444.516 806.668L439.58 796.571C438.233 793.878 439.355 790.288 442.048 788.942C444.74 787.596 448.331 788.717 449.677 791.41L454.613 801.507ZM439.131 770.094C440.477 772.786 439.355 776.376 436.663 777.723C433.97 779.069 430.38 777.947 429.034 775.255L424.097 765.157C422.751 762.465 423.873 758.875 426.566 757.528C429.258 756.182 432.848 757.304 434.195 759.997L439.131 770.094Z",
    fill: "#0071BC"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketingIos);
export default __webpack_public_path__ + "static/media/TicketingIos.f5699be5a232dcffadee9adbe5196125.svg";
export { ForwardRef as ReactComponent };